import { Dayjs } from 'dayjs';

import { SDate } from '@summit/core';
import { Interval, IntervalAbbreviationMapping, MoneyFormatter, RateFormatter } from '@summit/models';

import { EboObject } from '../base-classes/ebo-object';
import { Company } from '../organization/company/company';
import { ExpenseType, ExpenseTypeMapping } from '../payroll/expense/expense-type.enum';
import { Truck } from './truck';

export class TruckExpense extends EboObject {
  startTime: Dayjs;
  endTime: Dayjs;
  truckID: string;
  truck: Truck;
  companyID: string;
  company: Company;
  externalCompanyID: string;
  externalCompany: Company;
  interval: Interval;
  type: ExpenseType;
  amount: number;
  mileageRate: number;
  restriction: number;
  comment: string;

  constructor(jsonData?: Partial<TruckExpense>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.startTime) {
        this.startTime = SDate.newUtc(jsonData.startTime);
        //console.log(`jsonData.startTime parsed: ${this.startTime.toUTCString()}`, jsonData.startTime, this.startTime);
        //console.log(`jsonData.startTime parsed: ${this.startTime.toUTCString()}`, jsonData.startTime, this.startTime);
      }
      if (jsonData.endTime) {
        this.endTime = SDate.newUtc(jsonData.endTime);
      }
      if (jsonData.truck) {
        this.truck = new Truck(jsonData.truck);
      }
      if (jsonData.company) {
        this.company = new Company(jsonData.company);
      }
      if (jsonData.externalCompany) {
        this.externalCompany = new Company(jsonData.externalCompany);
      }
    }
    this.startTime ??= SDate.getNormalized();
  }

  get name(): string {
    return `${this.truck?.shortName}: ${ExpenseTypeMapping[this.type]} ${this.startTime?.format('yyyyMMDD')}--${
      this.endTime?.format('yyyyMMDD') ?? 'Current'
    }`;
  }
  get truckShortName(): string {
    return this.truck?.shortName;
  }
  get defaultSort(): string {
    const response: string[] = [];
    if (this.truck) {
      response.push(`${this.truck?.shortName}-`);
    }
    if (this.type) {
      response.push(`${ExpenseTypeMapping[this.type]}-`);
    }
    if (this.startTime) {
      response.push(`${this.startTime.format('yyyyMMDD')}:`);
    } else {
      response.push('~~~~~~~~');
    }
    if (this.endTime) {
      response.push(`${this.endTime.format('yyyyMMDD')}`);
    } else {
      response.push('~~~~~~~~');
    }
    return response.join();
  }

  toShortString(format?: string) {
    const response = new Array<string>();
    if (format != 'truck' && this.truck) {
      response.push(this.truck.shortName);
    }
    response.push(`${ExpenseTypeMapping[this.type]}:`);
    if (this.company) {
      response.push(this.company.abbreviation);
    }
    if (this.company && this.externalCompany) {
      response.push('=>');
    }
    if (this.externalCompany) {
      response.push(this.externalCompany.abbreviation);
    }
    if (this.amount) {
      response.push(`${MoneyFormatter(this.amount)} (${IntervalAbbreviationMapping[this.interval]})`);
    }
    if (this.mileageRate) {
      response.push(`${RateFormatter(this.mileageRate)}/Mi`);
    }
    return response.join(' ');
  }
}
